import {Store,Module,ActionContext} from 'vuex'
import ListModule from './list-module'
import ListState from './list-state'
import EmailSetting from '../entities/emailSetting'

import Ajax from '../../lib/ajax'
import PageResult from '@/store/entities/page-result';
import ListMutations from './list-mutations'


interface EmailSettingState extends ListState<EmailSetting>{
    emailSetting:EmailSetting
    editEmailSetting:EmailSetting

}

class EmailSettingMutations extends ListMutations<EmailSetting>{

}

class EmailSettingModule extends ListModule<EmailSettingState,any,EmailSetting>{
    state={
        totalCount:0,
        currentPage:1,
        pageSize:10,
        list: new Array<EmailSetting>(),
        loading:false,
        editEmailSetting:new EmailSetting(),
        selectEmailSetting:new EmailSetting(),
      
    
    
    }
    actions={

        async selectEmailSetting(context:ActionContext<EmailSettingState,any>,payload:any){
            context.state.editEmailSetting=payload.data;
        },
     
        async saveEmailSetting(context:ActionContext<EmailSettingState,any>,payload:any){
         
        
            let reponse=await Ajax.post('/api/services/app/Setting/SaveEmailSetting',payload.data);
          
            let page=reponse.data.result as PageResult<EmailSetting>;
            context.state.totalCount=page.totalCount;
            context.state.list=page.items;
        },
        async updateEmailSetting(context:ActionContext<EmailSettingState,any>,payload:any){
         
        
            let reponse=await Ajax.put('/api/services/app/Setting/UpdateEmailSetting',payload.data);
          
            let page=reponse.data.result as PageResult<EmailSetting>;
            context.state.totalCount=page.totalCount;
            context.state.list=page.items;
        },
        async getEmailSettings(context:ActionContext<EmailSettingState,any>,payload:any){
          
           // context.state.loading=true;
            let reponse=await Ajax.get('/api/services/app/Setting/GetEmailSettings',payload.data);
          
           // context.state.loading=false;
            let page=reponse.data.result as PageResult<EmailSetting>;
            context.state.totalCount=page.totalCount;
            context.state.list=page.items;
        },
       
     
   
 
    };
    mutations={
        setCurrentPage(state:EmailSettingState,page:number){
            state.currentPage=page;
        },
        setPageSize(state:EmailSettingState,pagesize:number){
            state.pageSize=pagesize;
        },
    }
}
const emailSettingModule=new EmailSettingModule();
export default emailSettingModule;